import { httpService } from '~/Services/Service';

// W-0617 — Mapeamento Geral Estoque
// Fonte backend: Setpar.APIRest/Controllers/Relatorios/MapeamentoGeralEstoqueController.cs
// RoutePrefix: "gerencial-estoque" (sem /api/ — APIBASE já cobre).
// httpService já faz unwrap do .data (usar `res`, não `res.data`).

const BASE = '/gerencial-estoque';

const listarMoedas = () => httpService.get(`${BASE}/moedas`);

const listarGruposEmpresa = () => httpService.get(`${BASE}/grupos-empresa`);

// JSON snake_case global (SnakeCaseNamingStrategy): CodigosGrupoEmpresa -> codigos_grupo_empresa,
// CodigoMoeda -> codigo_moeda, MostraCusto -> mostra_custo.
const gerar = ({ codigosGrupoEmpresa, codigoMoeda, mostraCusto }) =>
  httpService.post(`${BASE}/gerar`, {
    codigos_grupo_empresa: codigosGrupoEmpresa,
    codigo_moeda: codigoMoeda,
    mostra_custo: mostraCusto,
  });

export default { listarMoedas, listarGruposEmpresa, gerar };
